import {getWizardListFromBackend} from "../api/wizard-api";
import {setLeadPopup} from "../globalLogic/globalActions";
import {getErrorPopupObject} from "../components/helpers/popupFunctions";
import {getConflictingWizardSteps, getUpdatedAllWizardValues} from "./wizardLogicOld";

export const SET_WIZARD_LIST = "SET_WIZARD_LIST";
export const SET_WIZARD_ACTIVE_ITEM = "SET_WIZARD_ACTIVE_ITEM";
export const SET_WIZARD_ACTIVE_STEP = "SET_WIZARD_ACTIVE_STEP";
export const SET_WIZARD_SELECTED_VALUES = "SET_WIZARD_SELECTED_VALUES";
export const SET_ALL_WIZARD_SELECTED_VALUES = "SET_ALL_WIZARD_SELECTED_VALUES";
export const RESTORE_ALL_WIZARD_SELECTED_VALUES = "RESTORE_ALL_WIZARD_SELECTED_VALUES";
export const SET_WIZARD_MISSING_FEATURES = "SET_WIZARD_MISSING_FEATURES";

export const getWizardList = () => {
  return async (dispatch) => {
    const {wizardList, error} = await getWizardListFromBackend();
    if (error) {
      dispatch(setLeadPopup(getErrorPopupObject(error)));
    } else if (!wizardList.length) {
      dispatch(setLeadPopup(getErrorPopupObject("No wizards found")));
    }
    if (document.kvConfig.devMode) {
      console.log("wizardList", wizardList);
    }
    const wizardsArray = Array.isArray(wizardList.wizardList) ? wizardList.wizardList : wizardList;
    const nextActiveItem = document.kvConfig.wizardId
      ? wizardsArray.find(wizItem => wizItem.id === document.kvConfig.wizardId) || wizardsArray[0]
      : wizardsArray[0];
    dispatch(setWizardActiveItem(nextActiveItem));
    dispatch(setWizardList(wizardList));
  }
};

export const setWizardList = (wizardList) => ({
  type: SET_WIZARD_LIST,
  payload: {wizardList}
});

// export const setWizardActiveItem = (wizardActiveItem, quoteIndex = null) => {
export const setWizardActiveItem = (wizardActiveItem) => {
  return (dispatch) => {
  // return (dispatch, getState) => {
    // const {quotesState} = getState();

    dispatch({
      type: SET_WIZARD_ACTIVE_ITEM,
      payload: {
        wizardActiveItem,
        // quoteIndex: Number.isInteger(quoteIndex) ? quoteIndex : quotesState.activeQuoteIndex,
        quoteIndex: 0,
      }
    })
  }
};

export const setWizardActiveStep = (wizardActiveStep) => {
  return (dispatch, getState) => {
    // const {quotesState, wizardState} = getState();
    const {wizardState} = getState();

    let wizardConflictingSteps = wizardState.wizardConflictingSteps;
    let newWizValues = Object.assign({}, wizardState.wizardSelectedValues);
    if (wizardState.wizardConflictingSteps.length) {
      Object.keys(wizardState.wizardSelectedValues).reverse().forEach(selectedKeyNumber => { // erase conflicting selected steps!
        if (selectedKeyNumber >= wizardActiveStep) {
          delete newWizValues[selectedKeyNumber]
        }
      });
      wizardConflictingSteps = [];
    }
    let allWizardsValues = wizardState.allWizardsValues;
    if (wizardState.wizardActiveItem) {
      allWizardsValues = wizardState.allWizardsValues.map(wizObject => {
        // if (wizObject.wizardItemId === wizardState.wizardActiveItem.id && wizObject.quoteIndex === quotesState.activeQuoteIndex) {
        if (wizObject.wizardItemId === wizardState.wizardActiveItem.id && wizObject.quoteIndex === 0) {
          wizObject.lastVisitedStep = wizardActiveStep // keep it up to date to be able to restore
          if (wizardState.wizardConflictingSteps.length) {
            wizObject.wizardSelectedValues = Object.assign({}, newWizValues)
          }
        }
        return wizObject
      })
    }

    dispatch({
      type: SET_WIZARD_ACTIVE_STEP,
      payload: {
        wizardActiveStep,
        wizardSelectedValues: newWizValues,
        wizardConflictingSteps,
        allWizardsValues,
        // quoteIndex: quotesState.activeQuoteIndex,
        quoteIndex: 0,
      }
    })
  }
}

export const setWizardSelectedValues = (wizardSelectedValues, direct = false, wizardItem = null) => {
  return (dispatch, getState) => {
    const {wizardState} = getState();
    const wizardActiveItem = wizardItem || wizardState.wizardActiveItem;

    let wizardConflictingSteps = wizardState.wizardConflictingSteps;

    let newWizValues = direct
      ? Object.assign({}, wizardSelectedValues)
      : Object.assign({}, wizardState.wizardSelectedValues, wizardSelectedValues);

    if (!direct && wizardSelectedValues && Object.keys(wizardSelectedValues).length === 1) {
      wizardConflictingSteps = getConflictingWizardSteps(
        newWizValues,
        {wizardActiveItem, quoteIndex: 0, wizardSelectedValues},
      );
    }

    if (wizardActiveItem) {
      // console.log("wizardConflictingSteps", action.payload.wizardConflictingSteps);
      // this works for QKB UI only for now, we are not using it on lixil
      const allWizardsValues = wizardConflictingSteps.length // do not change them to be able to restore when wizard is closed
        ? wizardState.allWizardsValues
        : getUpdatedAllWizardValues(wizardState, 0, wizardActiveItem.id, newWizValues);

      dispatch({
        type: SET_WIZARD_SELECTED_VALUES,
        payload: {
          quoteIndex: 0,
          wizardSelectedValues: newWizValues,
          allWizardsValues,
          wizardConflictingSteps
        }
      });

      return;
    }

    dispatch({
      type: SET_WIZARD_SELECTED_VALUES,
      payload: {
        wizardSelectedValues: newWizValues,
        wizardConflictingSteps,
        // direct,
        quoteIndex: 0,
        // wizardActiveItem: wizardItem || wizardState.wizardActiveItem,
        // fabricatorState,
        // cartItems: cartState.cartItems
      }
    })
  }
}

export const setAllWizardSelectedValues = (wizardSelectedValues, quoteIndex, wizardItemId) => ({
  type: SET_ALL_WIZARD_SELECTED_VALUES,
  payload: {wizardSelectedValues, quoteIndex, wizardItemId}
});

export const updateAllWizardValues = (allWizardsValues) => ({
  type: RESTORE_ALL_WIZARD_SELECTED_VALUES,
  payload: {allWizardsValues}
})
